/**
 * Minimal spinner fallback rendered while a lazy-loaded screen chunk is
 * in flight. Kept extremely small (two div + inline style) so it costs
 * essentially nothing on the initial bundle — the whole point of code
 * splitting is to avoid loading screens we don't need yet.
 */
export default function LoadingPage() {
  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="screen-loading"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 40,
        gap: 10,
        color: 'var(--slate-500)',
      }}
    >
      <div
        aria-hidden="true"
        style={{
          width: 22,
          height: 22,
          borderRadius: '50%',
          border: '2px solid var(--slate-200, #e2e8f0)',
          borderTopColor: 'var(--navy, #0f1e3d)',
          animation: 'sentinel-spin 0.9s linear infinite',
        }}
      />
      <div style={{ fontSize: 12 }}>Loading screen…</div>
      <style>{`@keyframes sentinel-spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
